import { Typography } from '@mui/material';
import * as React from 'react';
import {
  Datagrid,
  DateField,
  NumberField,
  ResourceContextProvider,
  ShowButton,
  TextField,
  useGetList,
  useRecordContext,
} from 'react-admin';

import {
  AdminCohortDetailsFragment,
  AdminUserDetailsFragment,
} from '../../../../graphql/types';
import InfiniteList from '../../components/InfiniteList';

export const useCoachActiveCohortCount = (
  user: Pick<AdminUserDetailsFragment, 'id' | 'isCoach'> | undefined,
) => {
  const { total } = useGetList<AdminCohortDetailsFragment>(
    'Cohort',
    {
      filter: { coachId: user?.id },
      pagination: { page: 1, perPage: 1 },
      sort: { field: 'startDate', order: 'DESC' },
    },
    { enabled: !!user?.isCoach },
  );
  return total ?? 0;
};

export const CoachCohortsTab: React.FC = () => {
  const record = useRecordContext<AdminUserDetailsFragment>();
  if (!record) {
    return null;
  }

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Active cohorts this coach supports. Coaches are added to or removed from
        a cohort on the cohort&apos;s edit page.
      </Typography>
      <ResourceContextProvider value="Cohort">
        <InfiniteList
          filter={{ coachId: record.id }}
          disableSyncWithLocation
          storeKey={`coach-${record.id}-cohorts`}
          actions={false}
          // Embedded in the user's show page — don't override the title bar.
          title={false}
          empty={false}
        >
          <Datagrid bulkActionButtons={false} rowClick="show">
            <TextField source="name" sortable={false} />
            <DateField
              source="startDate"
              label="Start Date"
              showTime
              sortable={false}
            />
            <DateField
              source="endDate"
              label="End Date"
              showTime
              sortable={false}
            />
            <NumberField
              source="members.count"
              label="Members"
              sortable={false}
            />
            <ShowButton />
          </Datagrid>
        </InfiniteList>
      </ResourceContextProvider>
    </>
  );
};
